"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _BoumClaimsImpl_defaulted, _BoumClaimsImpl_ec, _BoumClaimsImpl_toWire, _BoumBuilder_claims;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoumBuilder = exports.BoumClaimsImpl = void 0;
exports.toEntity = toEntity;
exports.DefaultBoumClaims = DefaultBoumClaims;
exports.TestBoumClaims = TestBoumClaims;
exports.FromBoumWireClaims = FromBoumWireClaims;
const boum_claims_v1_1 = require("./boum-claims-v1");
const boum_claims_v2_1 = require("./boum-claims-v2");
const boum_right_1 = require("./boum-right");
const claims_1 = require("./claims");
function toEntity(x) {
    var _a;
    return {
        version: (_a = x.version) !== null && _a !== void 0 ? _a : 'V1',
        userRights: claims_1.WithDefault.from(boum_right_1.BoumRightEnDeCoder.toPermissions(x.userRights), boum_right_1.BoumRightEnDeCoder.toPermissions()),
        tenants: claims_1.WithDefault.from(x.tenants, []),
        customerTenants: claims_1.WithDefault.from(x.customerTenants, []),
        operatorTenants: claims_1.WithDefault.from(x.operatorTenants, []),
        ridepoolingServiceTenants: claims_1.WithDefault.from(x.ridepoolingServiceTenants, []),
        fleets: claims_1.WithDefault.from(x.fleets, []),
        serviceAreas: claims_1.WithDefault.from(x.serviceAreas, []),
        userId: claims_1.WithDefault.from(x.userId, ''),
        backofficeUsername: claims_1.WithDefault.from(x.backofficeUsername, ''),
        isSystemUser: claims_1.WithDefault.from(x.isSystemUser, false),
    };
}
/**
 * @deprecated use TestBoumClaims
 */
function DefaultBoumClaims(version = 'V1') {
    return TestBoumClaims(version);
}
function TestBoumClaims(version = 'V1') {
    return {
        version: version,
        userRights: [boum_right_1.BoumRight.ACCOUNTING_RECORDS_CRUD],
        tenants: ['tenant', 'moia'],
        customerTenants: ['customer-tenant', 'moia'],
        operatorTenants: ['operator-tenant', 'moia'],
        ridepoolingServiceTenants: ['ridepooling-service-tenant', 'moia'],
        fleets: ['fleet1', 'fleet2'],
        serviceAreas: ['service-area', 'moia'],
        userId: 'default-user-id',
        backofficeUsername: 'default-backoffice-username',
        isSystemUser: true,
    };
}
class BoumClaimsImpl {
    constructor(ec, params, toWire) {
        _BoumClaimsImpl_defaulted.set(this, void 0);
        _BoumClaimsImpl_ec.set(this, void 0);
        _BoumClaimsImpl_toWire.set(this, void 0);
        this.version = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").version;
        };
        this.userRights = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").userRights.val;
        };
        /** @deprecated Use specific tenant types (customerTenants, operatorTenants, ridepoolingServiceTenants) instead */
        this.tenants = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").tenants.val;
        };
        this.customerTenants = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").customerTenants.val;
        };
        this.operatorTenants = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").operatorTenants.val;
        };
        this.ridepoolingServiceTenants = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").ridepoolingServiceTenants.val;
        };
        this.fleets = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").fleets.val;
        };
        this.serviceAreas = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").serviceAreas.val;
        };
        this.userId = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").userId.val;
        };
        this.backofficeUsername = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").backofficeUsername.val;
        };
        this.isSystemUser = () => {
            return __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").isSystemUser.val;
        };
        __classPrivateFieldSet(this, _BoumClaimsImpl_defaulted, params, "f");
        __classPrivateFieldSet(this, _BoumClaimsImpl_toWire, toWire, "f");
        __classPrivateFieldSet(this, _BoumClaimsImpl_ec, ec, "f");
    }
    wireUserRights() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").userRights) ? this.userRights() : undefined;
    }
    /** @deprecated Use specific tenant types (customerTenants, operatorTenants, ridepoolingServiceTenants) instead */
    wireTenants() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").tenants) ? this.tenants() : undefined;
    }
    wireCustomerTenants() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").customerTenants)
            ? this.customerTenants()
            : undefined;
    }
    wireOperatorTenants() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").operatorTenants)
            ? this.operatorTenants()
            : undefined;
    }
    wireRidepoolingServiceTenants() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").ridepoolingServiceTenants)
            ? this.ridepoolingServiceTenants()
            : undefined;
    }
    wireFleets() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").fleets) ? this.fleets() : undefined;
    }
    wireServiceAreas() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").serviceAreas)
            ? this.serviceAreas()
            : undefined;
    }
    wireUserId() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").userId) ? this.userId() : undefined;
    }
    wireBackofficeUsername() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").backofficeUsername)
            ? this.backofficeUsername()
            : undefined;
    }
    wireIsSystemUser() {
        return (0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").isSystemUser)
            ? this.isSystemUser()
            : undefined;
    }
    wireIsError() {
        return __classPrivateFieldGet(this, _BoumClaimsImpl_ec, "f").isError();
    }
    isError() {
        return __classPrivateFieldGet(this, _BoumClaimsImpl_ec, "f").isError();
    }
    errors() {
        return __classPrivateFieldGet(this, _BoumClaimsImpl_ec, "f").errors;
    }
    lastError() {
        return __classPrivateFieldGet(this, _BoumClaimsImpl_ec, "f").lastError();
    }
    toJSON() {
        return __classPrivateFieldGet(this, _BoumClaimsImpl_toWire, "f").call(this, __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f"));
    }
    toParams() {
        const ret = {};
        ret.version = __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").version;
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").userRights)) {
            ret.userRights = __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").userRights.val.toEnums();
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").tenants)) {
            ret.tenants = (0, claims_1.sanitizeStringArray)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").tenants.val);
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").customerTenants)) {
            ret.customerTenants = (0, claims_1.sanitizeStringArray)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").customerTenants.val);
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").serviceAreas)) {
            ret.serviceAreas = (0, claims_1.sanitizeStringArray)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").serviceAreas.val);
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").operatorTenants)) {
            ret.operatorTenants = (0, claims_1.sanitizeStringArray)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").operatorTenants.val);
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").ridepoolingServiceTenants)) {
            ret.ridepoolingServiceTenants = (0, claims_1.sanitizeStringArray)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").ridepoolingServiceTenants.val);
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").fleets)) {
            ret.fleets = (0, claims_1.sanitizeStringArray)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").fleets.val);
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").userId)) {
            ret.userId = __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").userId.val;
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").backofficeUsername)) {
            ret.backofficeUsername = __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").backofficeUsername.val;
        }
        if ((0, claims_1.isSome)(__classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").isSystemUser)) {
            ret.isSystemUser = __classPrivateFieldGet(this, _BoumClaimsImpl_defaulted, "f").isSystemUser.val;
        }
        return ret;
    }
}
exports.BoumClaimsImpl = BoumClaimsImpl;
_BoumClaimsImpl_defaulted = new WeakMap(), _BoumClaimsImpl_ec = new WeakMap(), _BoumClaimsImpl_toWire = new WeakMap();
function FromBoumWireClaims(claims, val = {}) {
    if (typeof claims.boV2 === 'string' || val.version === 'V2') {
        return (0, boum_claims_v2_1.FromBoumWireClaimsV2)(claims, { ...val, version: 'V2' });
    }
    return (0, boum_claims_v1_1.FromBoumWireClaimsV1)(claims, { ...val, version: 'V1' });
}
class BoumBuilder {
    constructor(claims) {
        _BoumBuilder_claims.set(this, void 0);
        __classPrivateFieldSet(this, _BoumBuilder_claims, claims, "f");
    }
    build(version) {
        if (!version) {
            version = __classPrivateFieldGet(this, _BoumBuilder_claims, "f").version;
        }
        if (version === 'V2') {
            return (0, boum_claims_v2_1.FromBoumWireClaimsV2)({}, { ...__classPrivateFieldGet(this, _BoumBuilder_claims, "f"), version: 'V2' });
        }
        else {
            return (0, boum_claims_v1_1.FromBoumWireClaimsV1)({}, { ...__classPrivateFieldGet(this, _BoumBuilder_claims, "f"), version: 'V1' });
        }
    }
    version(version) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").version = version;
        return this;
    }
    userRights(userRights) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").userRights = userRights;
        return this;
    }
    tenants(tenants) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").tenants = tenants;
        return this;
    }
    customerTenants(customerTenants) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").customerTenants = customerTenants;
        return this;
    }
    operatorTenants(operatorTenants) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").operatorTenants = operatorTenants;
        return this;
    }
    ridepoolingServiceTenants(ridepoolingServiceTenants) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").ridepoolingServiceTenants = ridepoolingServiceTenants;
        return this;
    }
    fleets(fleets) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").fleets = fleets;
        return this;
    }
    serviceAreas(serviceAreas) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").serviceAreas = serviceAreas;
        return this;
    }
    userId(userId) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").userId = userId;
        return this;
    }
    backofficeUsername(backofficeUsername) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").backofficeUsername = backofficeUsername;
        return this;
    }
    isSystemUser(isSystemUser) {
        __classPrivateFieldGet(this, _BoumBuilder_claims, "f").isSystemUser = isSystemUser;
        return this;
    }
}
exports.BoumBuilder = BoumBuilder;
_BoumBuilder_claims = new WeakMap();
//# sourceMappingURL=boum-claims.js.map